<!--
@component
Modal copyright line.
-->
<script lang="ts">
  interface Props {
    full?: boolean;
  }

  let { full = false }: Props = $props();

  const year = new Date().getFullYear();
</script>

{#if full}
  © {year} Modal Labs, Inc. All rights reserved.
{:else}
  © Modal {year}
{/if}
